<ui-modal modalTitle="Edit Selected Products" size="xl" [showBackButton]="canGoBack()" (back)="goToPreviousStep()" [scrollable]="true">

	<ng-container *ngIf="step === 'operation'">
		<div class="alert alert-info">
			<i class="wq wq-info mr-1"></i> These operations make permanent changes to the selected products. You will have a chance to review which products will be affected in the last step.
		</div>
		<div class="d-flex flex-wrap justify-content-center">
			<div class="flex-weight-1 px-2" style="min-width: 15rem;">
				<h3 class="my-3 text-center">Labour</h3>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('labour_add')">Add labour</button>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('labour_remove_selected')">Remove selected labour</button>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('labour_remove_all')">Remove all labour</button>
			</div>
			<div class="flex-weight-1 px-2" style="min-width: 15rem;">
				<h3 class="my-3 text-center">Accessories</h3>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('accessory_add')">Add accessories</button>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('accessory_remove_selected')">Remove selected accessories</button>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('accessory_remove_all')">Remove all accessories</button>
			</div>
			<div class="flex-weight-1 px-2" style="min-width: 15rem;">
				<h3 class="my-3 text-center">Counters</h3>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('counter_add')">Add counters</button>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('counter_remove_selected')">Remove selected counters</button>
				<button class="btn btn-outline-secondary d-block w-100 my-2" (click)="setOperation('counter_remove_all')">Remove all counters</button>
			</div>
		</div>
	</ng-container>

	<div *ngIf="operation && step !== 'operation'" class="alert alert-info pb-0">
		<ng-container *ngIf="operation === 'labour_add'">
			<h3>Add labour</h3>
			<p>The selected labour will be added to each selected product, in addition to the existing labour they may already have. If a product already has the labour type, the hours will be added to the existing entry.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'labour_remove_selected'">
			<h3>Remove selected labour</h3>
			<p>The labour types you pick will be removed only from products that currently have them. Other labour on those products is not affected.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'labour_remove_all'">
			<h3>Remove all labour</h3>
			<p>All labour will be removed from each selected product.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'accessory_add'">
			<h3>Add accessories</h3>
			<p>The selected accessories will be added to each selected product, in addition to the accessories they may already have. If a product already has the accessory, its default quantity is left unchanged.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'accessory_remove_selected'">
			<h3>Remove selected accessories</h3>
			<p>The accessories you pick will be removed only from products that currently have them. Other accessories on those products are not affected.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'accessory_remove_all'">
			<h3>Remove all accessories</h3>
			<p>All accessories will be removed from each selected product. Accessories provided by a catalogue owner are not affected.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'counter_add'">
			<h3>Add counters</h3>
			<p>The selected counters will be added to each selected product, in addition to the counters they may already have. If a product already has the counter, the amount will be added to the existing entry.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'counter_remove_selected'">
			<h3>Remove selected counters</h3>
			<p>The counters you pick will be removed only from products that currently have them. Other counters on those products are not affected.</p>
		</ng-container>

		<ng-container *ngIf="operation === 'counter_remove_all'">
			<h3>Remove all counters</h3>
			<p>All counters will be removed from each selected product.</p>
		</ng-container>
	</div>

	<ng-container *ngIf="step === 'select_labour'">
		<div class="scrollable" style="height: 425px;">
			<div *ngIf="dataLoaded">
				<h3>Labour to add</h3>
				<p *ngIf="bulkData.labour.length === 0" class="text-secondary">No labour.</p>
				<table *ngIf="bulkData.labour.length > 0" class="table table-sm table-hover vam">
					<thead>
						<tr>
							<th>Labour Type</th>
							<th class="shrink nowrap text-center">Hours</th>
							<th class="shrink nowrap text-center">Days</th>
							<th class="text-center">Price</th>
							<th class="shrink"></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let labour of bulkData.labour">
							<td class="shrink">
								<select class="custom-select" style="width: auto;" [(ngModel)]="labour.labour_type_id" (change)="updateLabour(labour)">
									<option [ngValue]="null">None</option>
									<optgroup *ngFor="let category of labourCategories" label="{{category.description}}">
										<option *ngFor="let item of category.types" [ngValue]="item.id">{{item.description}}</option>
									</optgroup>
								</select>
							</td>
							<td class="shrink"><input class="form-control text-right text-bold" style="width: 6.25rem;" [(ngModel)]="labour.labour_hours" (change)="formatLabourHours()" (input)="labourHoursChanged(labour)" autocomplete="chrome-off"></td>
							<td class="shrink"><input class="form-control text-right" [ngClass]="{ invisible: labour.hours_per_day < 0.01 }" style="width: 6.25rem;" [(ngModel)]="labour.labour_days" (change)="formatLabourHours()" (input)="labourDaysChanged(labour)" autocomplete="chrome-off"></td>
							<td class="text-center">{{getLabourPrice(labour) | currency:labour.currency_id}}</td>
							<td class="shrink nowrap">
								<button type="button" class="btn btn-outline-secondary btn-sm px-1 border-0" (click)="deleteLabour(labour)"><i class="wq wq-close"></i></button>
							</td>
						</tr>
					</tbody>
				</table>
				<button type="button" class="btn btn-outline-success btn-sm mr-2" (click)="addLabour()"><i class="wq wq-add mr-2"></i>Add labour</button>
			</div>

			<div *ngIf="!dataLoaded" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<ui-wait></ui-wait>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'select_labour_types'">
		<div class="scrollable" style="height: 425px;">
			<ng-container *ngIf="dataLoaded">
				<h3>Labour types to remove</h3>

				<p *ngIf="!inUseLabourTypes.length" class="text-secondary">
					None of the selected products have any labour assigned.
				</p>

				<ng-container *ngIf="inUseLabourTypes.length">
					<p class="text-secondary">Pick one or more labour types below. Matching labour will be removed only from products that currently have it &mdash; other products and other labour types are not affected.</p>

					<div class="d-flex flex-wrap mt-3">
						<label *ngFor="let lt of inUseLabourTypes" class="selectable d-flex align-items-center p-3 border rounded mb-3 mr-3" style="min-width: 18rem; flex-basis: 30%;" [ngClass]="{ 'border-primary bg-primary-25': isLabourTypeSelected(lt.id) }">
							<label class="custom-control custom-checkbox m-0 mr-3">
								<input type="checkbox" class="custom-control-input" [checked]="isLabourTypeSelected(lt.id)" (change)="toggleLabourTypeSelected(lt.id)">
								<span class="custom-control-label"></span>
							</label>
							<div class="flex-weight-1">
								<div class="text-bold">{{lt.description}}</div>
								<div class="text-secondary text-small">
									{{lt.product_count}} product{{lt.product_count === 1 ? '' : 's'}}
								</div>
							</div>
						</label>
					</div>
				</ng-container>
			</ng-container>

			<div *ngIf="!dataLoaded" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<ui-wait></ui-wait>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'select_accessories'">
		<div class="scrollable" style="height: 425px;">
			<div *ngIf="dataLoaded">
				<h3>Accessories to add</h3>
				<p *ngIf="bulkData.accessories.length === 0" class="text-secondary">No accessories.</p>
				<table *ngIf="bulkData.accessories.length > 0" class="table table-sm table-hover vam">
					<thead>
						<tr>
							<th colspan="2">Product</th>
							<th class="shrink nowrap text-right">Default Quantity</th>
							<th class="shrink"></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of bulkData.accessories">
							<td class="shrink pr-0">
								<div *ngIf="item.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + item.image_url + '\')' | safeStyle"></div>
							</td>
							<td class="pl-0">
								<div *ngIf="item.short_description" class="text-bold">{{item.short_description}}</div>
								<div *ngIf="item.manufacturer_name || item.model" class="text-secondary">{{item.manufacturer_name}} {{item.manufacturer_name && item.model ? '/' : ''}} {{item.model}}</div>
								<div *ngIf="item.sku || item.manufacturer_sku" class="text-secondary text-tiny">{{item.sku || item.manufacturer_sku}}</div>
							</td>
							<td class="shrink nowrap text-right"><input class="form-control text-right" style="width: 7.5rem;" [(ngModel)]="item.default_quantity" (change)="formatAccessoryQuantities()" autocomplete="chrome-off"></td>
							<td class="shrink nowrap">
								<button type="button" class="btn btn-outline-secondary btn-sm px-1 border-0" (click)="deleteAccessory(item)"><i class="wq wq-close"></i></button>
							</td>
						</tr>
					</tbody>
				</table>
				<button type="button" class="btn btn-outline-success btn-sm mr-2" (click)="addAccessories()"><i class="wq wq-add mr-2"></i>Add accessories</button>
			</div>

			<div *ngIf="!dataLoaded" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<ui-wait></ui-wait>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'select_accessory_products'">
		<div class="scrollable" style="height: 425px;">
			<ng-container *ngIf="dataLoaded">
				<h3>Accessories to remove</h3>

				<p *ngIf="!inUseAccessories.length" class="text-secondary">
					None of the selected products have any accessories assigned.
				</p>

				<ng-container *ngIf="inUseAccessories.length">
					<p class="text-secondary">Pick one or more accessories below. Matching accessories will be removed only from products that currently have them &mdash; other products and other accessories are not affected.</p>

					<div class="d-flex flex-wrap mt-3">
						<label *ngFor="let acc of inUseAccessories" class="selectable d-flex align-items-center p-3 border rounded mb-3 mr-3" style="min-width: 18rem; flex-basis: 30%;" [ngClass]="{ 'border-primary bg-primary-25': isAccessorySelected(acc.id) }">
							<label class="custom-control custom-checkbox m-0 mr-3">
								<input type="checkbox" class="custom-control-input" [checked]="isAccessorySelected(acc.id)" (change)="toggleAccessorySelected(acc.id)">
								<span class="custom-control-label"></span>
							</label>
							<div class="flex-weight-1">
								<div class="text-bold">{{acc.description || acc.model || acc.sku}}</div>
								<div *ngIf="acc.sku" class="text-secondary text-tiny">{{acc.sku}}</div>
								<div class="text-secondary text-small">
									{{acc.product_count}} product{{acc.product_count === 1 ? '' : 's'}}
								</div>
							</div>
						</label>
					</div>
				</ng-container>
			</ng-container>

			<div *ngIf="!dataLoaded" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<ui-wait></ui-wait>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'select_counters'">
		<div class="scrollable" style="height: 425px;">
			<div *ngIf="dataLoaded">
				<h3>Counters to add</h3>

				<p *ngIf="!counters.length" class="text-secondary">No counters have been set up for your organisation.</p>

				<ng-container *ngIf="counters.length">
					<p *ngIf="bulkData.counters.length === 0" class="text-secondary">No counters.</p>
					<table *ngIf="bulkData.counters.length > 0" class="table table-sm table-hover vam">
						<thead>
							<tr>
								<th>Counter</th>
								<th class="shrink nowrap text-center">Amount</th>
								<th class="shrink"></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let counter of bulkData.counters">
								<td class="shrink">
									<select class="custom-select" style="width: auto;" [(ngModel)]="counter.counter_id">
										<option [ngValue]="null">None</option>
										<optgroup *ngFor="let group of counterGroups" label="{{group.description}}">
											<option *ngFor="let item of group.items" [ngValue]="item.id">{{item.description}}</option>
										</optgroup>
									</select>
								</td>
								<td class="shrink"><input class="form-control text-right text-bold" style="width: 6.25rem;" [(ngModel)]="counter.amount" (change)="formatCounterAmounts()" autocomplete="chrome-off"></td>
								<td class="shrink nowrap">
									<button type="button" class="btn btn-outline-secondary btn-sm px-1 border-0" (click)="deleteCounter(counter)"><i class="wq wq-close"></i></button>
								</td>
							</tr>
						</tbody>
					</table>
					<button type="button" class="btn btn-outline-success btn-sm mr-2" (click)="addCounter()"><i class="wq wq-add mr-2"></i>Add counter</button>
				</ng-container>
			</div>

			<div *ngIf="!dataLoaded" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<ui-wait></ui-wait>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'select_counter_types'">
		<div class="scrollable" style="height: 425px;">
			<ng-container *ngIf="dataLoaded">
				<h3>Counters to remove</h3>

				<p *ngIf="!inUseCounters.length" class="text-secondary">
					None of the selected products have any counters assigned.
				</p>

				<ng-container *ngIf="inUseCounters.length">
					<p class="text-secondary">Pick one or more counters below. Matching counters will be removed only from products that currently have them &mdash; other products and other counters are not affected.</p>

					<div class="d-flex flex-wrap mt-3">
						<label *ngFor="let ct of inUseCounters" class="selectable d-flex align-items-center p-3 border rounded mb-3 mr-3" style="min-width: 18rem; flex-basis: 30%;" [ngClass]="{ 'border-primary bg-primary-25': isCounterSelected(ct.id) }">
							<label class="custom-control custom-checkbox m-0 mr-3">
								<input type="checkbox" class="custom-control-input" [checked]="isCounterSelected(ct.id)" (change)="toggleCounterSelected(ct.id)">
								<span class="custom-control-label"></span>
							</label>
							<div class="flex-weight-1">
								<div class="text-bold">{{ct.description}}</div>
								<div class="text-secondary text-small">
									{{ct.product_count}} product{{ct.product_count === 1 ? '' : 's'}}
								</div>
							</div>
						</label>
					</div>
				</ng-container>
			</ng-container>

			<div *ngIf="!dataLoaded" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<ui-wait></ui-wait>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="step === 'confirm'">
		<div class="mb-2 scrollable" style="height: 425px;">
			<table *ngIf="dataLoaded" class="table table-hover vam">
				<thead>
					<tr>
						<th colspan="2" class="sticky">Product</th>
						<th class="sticky">Manufacturer</th>
						<th class="sticky">SKU</th>
						<th *ngIf="showBeforeAfter()" class="text-center sticky">{{beforeAfterLabel()}} Before</th>
						<th *ngIf="showBeforeAfter()" class="text-center sticky">{{beforeAfterLabel()}} After</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of products" [ngClass]="{ 'table-danger': item.issues?.length }">
						<td class="shrink pr-0">
							<div *ngIf="item.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + item.image_url + '\')' | safeStyle"></div>
						</td>
						<td class="pl-0">
							<div *ngIf="item.short_description" class="text-bold">{{item.short_description}}</div>
							<div *ngIf="item.model" class="text-secondary text-small">{{item.model}}</div>
							<div *ngFor="let issue of item.issues"><span class="badge badge-danger mt-1">Skipped: {{issue}}</span></div>
						</td>
						<td>{{item.manufacturer_name}}</td>
						<td class="text-small text-secondary">{{item.sku || item.manufacturer_sku}}</td>

						<td *ngIf="showBeforeAfter()" class="text-center">
							<span class="text-bold">{{getBeforeCount(item.id)}}</span>
						</td>
						<td *ngIf="showBeforeAfter()" class="text-center">
							<span class="text-bold">{{getAfterCount(item.id)}}</span>
						</td>
					</tr>
					<tr *ngIf="!products.length">
						<td [attr.colspan]="showBeforeAfter() ? 6 : 4" class="text-secondary">No products selected.</td>
					</tr>
				</tbody>
			</table>

			<div *ngIf="!dataLoaded" class="w-100 h-100 d-flex align-items-center justify-content-center">
				<ui-wait></ui-wait>
			</div>
		</div>

		<div *ngIf="dataLoaded && products.length" class="alert alert-danger mb-0 mt-3">
			Please review the list of selected products above. Once you submit this form, <b>changes made will be permanent</b>. You won't be able to undo them.
		</div>
	</ng-container>

	<button type="button" class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
	<div class="flex-weight-1" ui-modal-footer></div>
	<div *ngIf="step === 'confirm' && dataLoaded" ui-modal-footer>
		<div class="d-flex">
			<div class="mr-3">Selected products: {{countSelected}}</div>
			<div *ngIf="countSkipped > 0" class="mr-3 text-danger">Skipped: {{countSkipped}}</div>
			<div *ngIf="countAffected > 0" class="mr-3 text-success">Affected: {{countAffected}}</div>
		</div>
	</div>
	<button *ngIf="canGoForward()" type="button" class="btn btn-primary" (click)="goToNextStep()" [disabled]="disabled" ui-modal-footer><i class="wq wq-arrow-right mr-2"></i>Next</button>
	<button *ngIf="step === 'confirm'" type="submit" class="btn btn-primary" (click)="submitButton()" [disabled]="disabled || !dataLoaded || !countAffected" ui-modal-footer>Submit</button>
</ui-modal>

<modal-select-product (close)="productSelectModalClosed($event)"></modal-select-product>
